import React from "react";
import image from "../../assets/combinePics.webp";

const AboutSection: React.FC = () => {
  return (
    <section className="mt-16 w-full mx-auto text-gray-700 leading-relaxed">
      <div className="flex flex-col md:flex-row items-center gap-10 bg-white px-6 py-16 sm:px-10 md:px-16 lg:px-20 rounded-3xl mx-auto">
        {/* Text Section */}
        <div className="w-full md:w-1/2 text-gray-800">
          <h3 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-10 tracking-tight leading-tight">
            <span className="bg-black bg-clip-text text-transparent">
              About the Image Layout Creator
            </span>
          </h3>
          <p className="text-base leading-relaxed">
            Combine Multiple Images into One Page – Printable Layouts for A4,
            Legal, and Letter Sizes Need to merge images into a single page for
            easy printing? The Image Layout Creator is your go-to tool for
            combining multiple photos or graphics into one clean, structured
            layout. Whether you're printing on A4, Legal, or Letter size paper,
            this tool ensures your images fit perfectly — no extra cropping or
            editing needed. Create stunning printable photo collages,
            professional portfolios, visual project reports, or mood boards with
            ease. The tool offers flexible layout options, customizable titles,
            and intuitive controls, making it ideal for students, designers,
            teachers, or anyone needing to combine photos for printing. Whether
            you're organizing travel memories, compiling product shots, or
            crafting a creative visual story, this photo layout maker makes it
            fast, simple, and professional.
          </p>
          <p className="mt-6 text-base leading-relaxed">
            With the ability to export your layouts as PDF or image files, you
            can easily share your creations online, print them for physical use,
            or save them for later. The drag-and-drop interface ensures that
            editing and arranging images is simple, even for beginners.
          </p>
        </div>

        {/* Image Section */}
        <div className="w-full md:w-1/2">
          <img
            src={image}
            alt="Image Layout Creator preview"
            className="rounded-3xl shadow-2xl w-full h-auto object-cover transition-transform duration-500 hover:scale-105"
          />
        </div>
      </div>

      {/* Second Section */}
      <div className="w-full px-6 py-16 sm:px-10 md:px-16 lg:px-24 bg-gradient-to-br from-[#f5f7fa] via-[#edf2f7] to-[#e2e8f0] rounded-3xl shadow-inner overflow-hidden relative mt-16">
        {/* Glow Accents */}
        <div className="absolute top-[-5rem] right-[-5rem] w-72 h-72 bg-blue-300 opacity-20 blur-3xl rounded-full z-0 animate-pulse" />
        <div className="absolute bottom-[-4rem] left-[-4rem] w-52 h-52 bg-purple-300 opacity-20 blur-3xl rounded-full z-0 animate-pulse" />

        <div className="relative z-10">
          <h3 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-8 text-center tracking-tight leading-tight">
            <span className="bg-black bg-clip-text text-transparent">
              Why Use This Tool?
            </span>
          </h3>
          <p className="mb-16 text-center max-w-3xl mx-auto text-base text-gray-700">
            Save time and effort by quickly organizing your images into clean,
            professional layouts. Perfect for portfolios, presentations, or
            creative projects.
          </p>

          {/* Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                heading: "Instant Image Merge",
                text: "Quickly merge multiple images into a cohesive layout with just a few clicks — no design skills required.",
              },
              {
                heading: "Context Matters",
                text: "Add titles/captions for better context and organization, making your visuals more meaningful and easy to understand.",
              },
              {
                heading: "High-Quality Formats",
                text: "Export your layouts in stunning PDF or PNG formats — ready for print, presentations, or sharing anywhere.",
              },
              {
                heading: "All-In-One Tool",
                text: "Perfect for personal, educational, or professional projects — no matter the scope or skill level.",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="relative bg-[#5662e733] backdrop-blur-2xl border border-white/10 shadow-xl rounded-3xl p-6 sm:p-8 transition-all duration-300 hover:scale-[1.03] group"
              >
                <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-3">
                  {item.heading}
                </h2>
                <div className="w-8 h-1 bg-gradient-to-tr from-purple-500 to-blue-500 rounded-full mb-4" />
                <p className="text-gray-700 text-sm leading-relaxed">
                  {item.text}
                </p>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          <p className="mt-12 text-base text-gray-700 text-center">
            Start creating your custom image layouts today and experience the
            ease of
            <span className="text-blue-600 font-semibold">
              {" "}
              professional-quality results!
            </span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
